import axiosInstance from "../api/axiosInstance";

type TPasswordResetBody = {
  new_password1: string;
  new_password2: string;
};

interface OnboardingData {
  profession?: string;
  practice_size?: number;
  referral_source?: string;
  completed?: boolean;
  start_time?: string;
  reward_claimed?: boolean;
  group_practice_url?: string;
  colleague_name?: string;
  ehr?: string;
  timezone?: string;
}

interface UtmData {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
}

interface UpdateUserData {
  onboarding_data?: OnboardingData;
  utm_data?: UtmData;
  practice_area?: string;
  record_first?: boolean;
}

export const ensureCsrfToken = () => {
  return axiosInstance.get("/users/csrf/");
};

export const handleChangePassword = (passwordResetBody: TPasswordResetBody) => {
  return axiosInstance.post("/rest-auth/password/change/", passwordResetBody);
};

export const getUserData = () => {
  return axiosInstance.get("/users/user/");
};

export const getUserInfo = () => {
  return axiosInstance.get("/users/userinfo/");
};

export const patchUserInfo = async (data: UpdateUserData) => {
  const response = await axiosInstance.patch("/users/userinfo/", data);
  return response.data;
};

export const sendTeamInvitation = async (email: string) => {
  const response = await axiosInstance.post("/users/team-invite/", { email });
  return response.data;
};

export const getOnboardingCatalog = async () => {
  const response = await axiosInstance.get("/users/catalog/onboarding/");
  return response.data as {
    practice_areas: { code: string; label: string }[];
    specialties_by_area: Record<string, { code: string; label: string }[]>;
  };
};
